import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VoucherAtpComponent } from './voucher-atp.component';
import { ReactiveFormsModule } from '@angular/forms';
import { FormValidatorModule } from '../../shared/form-validator/form-validator.module';
import { MatInputModule } from '@angular/material/input';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { VoucherAtpInputsComponent } from './voucher-atp-inputs/voucher-atp-inputs.component';
import { VoucherAtpFormComponent } from './voucher-atp-form/voucher-atp-form.component';
import { MatDividerModule } from '@angular/material/divider';
import { MatSelectModule } from '@angular/material/select';
import { VoucherAtpFormHeaderComponent } from './voucher-atp-form-header/voucher-atp-form-header.component';
import { VoucherAtpParametersComponent } from './voucher-atp-parameters/voucher-atp-parameters.component';
import { ContextBaseToAtpHtmlPipe } from './service/context-base-to-atp-html.pipe';
import { TranslateModule } from '@ngx-translate/core';
import { ObjectKeysPipe } from './service/object-keys.pipe';

@NgModule({
  declarations: [
    VoucherAtpComponent,
    VoucherAtpInputsComponent,
    VoucherAtpFormComponent,
    VoucherAtpFormHeaderComponent,
    VoucherAtpParametersComponent,
    ContextBaseToAtpHtmlPipe
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatInputModule,
    FormValidatorModule,
    MatExpansionModule,
    MatButtonModule,
    MatIconModule,
    MatDividerModule,
    MatSelectModule,
    TranslateModule,
    ObjectKeysPipe
  ],
  exports: [VoucherAtpComponent]
})
export class VoucherAtpModule {}
